<h1 mat-dialog-title>Obaveštenje</h1>
<div mat-dialog-content>
  {{ message }}
</div>
<div mat-dialog-actions align="end">
  <button id="confirm-dialog-yes-button" mat-button [mat-dialog-close]="true">OK</button>
</div>